import { useBackendApi } from './backendApi';
import { BadRequestError } from "request-sender";

export enum OAuthProviderType {
  GOOGLE = 'google',
  APPLE = 'apple'
}

export interface OAuthUrlResponse {
  url: string;
}

export interface OAuthLoginRequest {
  code: string;
}

export interface OAuthLoginResponse {
  token: string;
}

export class RegisteredButNotLinkedError extends Error {
  private _email: string;

  constructor(email: string) {
    super('User is registered but not linked with the OAuth provider');

    this._email = email;

    Object.setPrototypeOf(this, RegisteredButNotLinkedError.prototype);
  }


  get email(): string {
    return this._email;
  }
}

export function useOAuthIdentityService() {
  const nekstApi = useBackendApi();

  const getOAuthUrl = async (provider: OAuthProviderType): Promise<string> => {
    const response = await nekstApi.get(`/oauth/${provider}/url`) as OAuthUrlResponse;
    return response.url;
  };

  const login = async (provider: OAuthProviderType, request: OAuthLoginRequest): Promise<string> => {
    try {
      const response = await nekstApi.post(`/oauth/${provider}/login`, request) as OAuthLoginResponse;
      return response.token;
    } catch (e) {
      if (e instanceof BadRequestError) {
        if (e.getErrorCode() === 'REGISTERED_BUT_NOT_LINKED') {
          throw new RegisteredButNotLinkedError(e.getResponseField('email', ''));
        }
      }

      throw e;
    }
  };

  return {
    getOAuthUrl,
    login,
  };
}
